import { createContext } from 'react';
import { IAuthContext } from './types';

const AuthContext = createContext<IAuthContext>({} as IAuthContext);

export default AuthContext;
